import { Subscription } from '@24i/nxg-sdk-photon/src';

export const getNextSubscriptionBillingDate = (subscription: Subscription) => {
    if (subscription?.expirationDate) {
        return subscription.expirationDate * 1000;
    }
    return 0;
};
